export default __webpack_public_path__ + "static/media/ic-stop-watch.3b2ded12.svg";